import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import TopCampLejeuneLawyersWrapper from "@components/layouts/topCampLejeuneLawyersWrapper";

export default function CampLejeuneApplicationHome(): ReactElement {
    return (
        <TopCampLejeuneLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <TermsAndConditions
                    category="Camp Lejeune"
                    domain="TopCampLejeuneLawyers.com"
                />
            </div>
        </TopCampLejeuneLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
